import React, { useContext, useEffect, useState } from 'react';
import { ThemeContext } from '../../context/ThemeContext';

import CustomButton from '../Componentization/CustomButton';
import CustomText from '../../styles/CustomText';
import useQssMnemonic from '../../hooks/useQssMnemonic';
import useSecureStorage from '../../hooks/useSecureStorage';

import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { checkMnemonic, RootState } from '../../store';

import * as bip39 from 'bip39'
import WebApp from '@twa-dev/sdk';

const WalletQssRecovery: React.FC = () => {
	const { theme } = useContext(ThemeContext)
	let navigate = useNavigate();
	const { t } = useTranslation();
	let dispatch = useDispatch();

	const { checkEmptyQssMnemonic, checkOldQssData } = useQssMnemonic()
	const { getBlockChain } = useSecureStorage()

	const [secretPhrase, setSecretPhrase] = useState<string>('')
	const [error, setError] = useState<boolean>(false)

	const handleRecovery = async () => {
		const trimmedSecretPhrase = secretPhrase.trim()
		const storeMnemonic = trimmedSecretPhrase.split(/\s+/)

		if (bip39.validateMnemonic(trimmedSecretPhrase)) {
			setError(false)
			// redux 에 비밀복구코드 배열 임시 저장
			const jsonMnemonic = JSON.stringify(storeMnemonic)
			dispatch(checkMnemonic(jsonMnemonic))

			navigate(`/WalletRecoveryProtection`, { replace: true, state: { } });
		} else {
			setError(true)
		}
	}

	const handleLoadQss = async (): Promise<void> => {
		try {
			// qss에 저장된 니모닉 데이터 있는지 확인
			const selNetwork = await getBlockChain()
			const isEmpty = await checkEmptyQssMnemonic(selNetwork);
			if(true === isEmpty) {
				// 이전 저장된 qss 니모닉 데이터 없음
				WebApp.showAlert(t('wallet_qss_recovery_message_13'));

				// CreateWallet 페이지로 이동
				setTimeout(() => {
					// @ts-ignore
					navigate(`/CreateWallet`)
				}, 500)

				return
			}

			// 이전 형식의 QSS 데이터 인지 확인
			const isOldData = await checkOldQssData(selNetwork);
			if (true === isOldData) {
				// QSS 데이터 형식이 호환되지 않는 이전 형식
				WebApp.showAlert(t('wallet_qss_recovery_message_14'));

				// CreateWallet 페이지로 이동
				setTimeout(() => {
					// @ts-ignore
					navigate(`/CreateWallet`)
				}, 500)

				return
			}

			// 저장된 qss 니모닉 데이터 있음
			// QssPassword 페이지로 이동
			console.log(t('wallet_qss_recovery_message_08'));
			setTimeout(() => {
				// @ts-ignore
				navigate(`/QssLoadPassword`, { replace: true, state: { } });
			}, 500)
		} catch (error) {
			console.warn('Error handling QSS load:', error);
		}
	};

	const styles = {
		header: {
			width: "100%",
			marginBottom: 20
		} as React.CSSProperties,
		title: {
			fontSize: 24,
			textAlign: 'left',
			marginBottom: 10
		} as React.CSSProperties,
		subtitle1: {
			fontSize: 18,
			textAlign: 'left'
		} as React.CSSProperties,
		subtitle2: {
			fontSize: 18,
			textAlign: 'left'
		} as React.CSSProperties,
		subtitle3: {
			fontSize: 18,
			textAlign: 'left',
			marginBottom: 5
		} as React.CSSProperties,
		warning1: {
			fontSize: 14,
			textAlign: 'left',
			marginTop: 10
		} as React.CSSProperties,
		warning2: {
			fontSize: 14,
			textAlign: 'left',
			marginBottom: 20
		} as React.CSSProperties,
		body: {
			width: "100%",
		} as React.CSSProperties,
		footer: {
			width: "100%",
			justifyContent: 'flex-end',
		} as React.CSSProperties,
		clearButton: {
			padding: 5
		} as React.CSSProperties,
		button: {
			borderRadius: 10,
			alignItems: 'center',
			width: '100%',
			height: 54,
			justifyContent: 'center'
		} as React.CSSProperties,
		buttonText: {
			color: theme.static_white,
			fontSize: 16
		} as React.CSSProperties,
	}

	return (
		<div className='container' style={{ backgroundColor: theme.background_normal }}>
			<div style={styles.header}>
				<CustomText weight="medium" style={{ ...styles.title, color: theme.label_strong }}>
					{t('wallet_qss_recovery_message_01')}
				</CustomText>
				<CustomText style={{ ...styles.subtitle1, color: theme.label_strong }}>
					{t('wallet_qss_recovery_message_02')}
				</CustomText>
				<CustomText style={{ ...styles.subtitle2, color: theme.label_strong }}>
					{t('wallet_qss_recovery_message_03')}
				</CustomText>
				<CustomText style={{ ...styles.subtitle3, color: theme.label_strong }}>
					{t('wallet_qss_recovery_message_04')}
				</CustomText>
				<CustomText style={{ ...styles.subtitle3, color: theme.label_strong }}>
					{t('wallet_qss_recovery_message_05')}
				</CustomText>
				<CustomText style={{ ...styles.warning1, color: theme.label_alternative }}>
					{t('wallet_qss_recovery_message_06')}
				</CustomText>
				<CustomText style={{ ...styles.warning2, color: theme.label_alternative }}>
					{t('wallet_qss_recovery_message_07')}
				</CustomText>
				<CustomText style={{ ...styles.warning2, color: theme.label_alternative }}>
					{t('wallet_qss_recovery_message_08')}
				</CustomText>

				<div style={styles.body}>
					<CustomText style={{ ...styles.warning2, color: theme.label_alternative }}>
						{t('wallet_qss_recovery_message_09')}
					</CustomText>
					<CustomText style={{ ...styles.warning2, color: theme.label_alternative }}>
						{t('wallet_qss_recovery_message_10')}
					</CustomText>
					<CustomText style={{ ...styles.warning2, color: theme.label_alternative }}>
						{t('wallet_qss_recovery_message_11')}
					</CustomText>
				</div>
			</div>

			<div style={styles.footer}>
				<CustomButton
					containerStyle={{ ...styles.button, backgroundColor: theme.primary_normal }}
					textStyle={styles.buttonText}
					onPress={handleLoadQss}
					text={t('wallet_qss_recovery_message_12')}
					withBackground={true}
					backgroundColor={theme.primary_normal}
				/>
			</div>
		</div>
	)
}

export default WalletQssRecovery
